<template>
  <v-app class="brand-fact-sheet-page" transition="fade-transition">
    <v-card tile transition="fade-transition">
      <v-container fluid v-if="type">
        <v-form class="brand-fact-sheet-form" ref="feedbackform" v-model="valid" lazy-validation>
          <!-- Start Story Tell or Others -->
          <v-layout wrap justify-center mb-2 v-if="type === campaignTypes.STORY_TELL">
            <v-flex xs12 md7 class="content">
              <v-row>
                <v-col cols="12" class="text-center pb-0">
                  <div class="avatar-logo">
                    <img :src="brandSheetLogo" alt="Logo" />
                  </div>
                </v-col>
                <v-col cols="12" class="pt-0">
                  <h2 class="form-title">STORYTELL - BRAND FACT SHEET</h2>
                </v-col>
              </v-row>
              <v-row class="mb-4">
                <v-col cols="12" class="text-center pb-0">
                  <v-img src="/static/img/brand_sheet/storytell_bg.jpg" ></v-img>
                </v-col>
              </v-row>
              <!-- Use separate sections rather than array lists for easier fields update -->
              <!-- Start Section One -->
              <v-row>
                <v-col cols="12" class="text-center pb-0">
                  <p class="h4 font-weight-bold mb-0">{{brandSheetFormSections.sectionOne.title}}</p>
                </v-col>
                <v-col cols="12" class="text-center pb-0">
                  <p class="h4 font-weight-bold mb-0">{{brandSheetFormSections.sectionOne.subtitle}}</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-layout wrap>
                    <v-flex :class="field.class ? field.class : 'xs12 md6'" v-for="(field, index) in brandSheetFormSections.sectionOne.fields" :key="index">
                      <div>
                        <p class="h4 font-weight-bold mb-2" v-if="field.label !== ''">{{field.label}} <span class="red--text" v-if="field.required">*</span></p>
                        <p v-else class="form-label"></p>
                        <p class="caption caption-text ma-0 pb-2" v-if="field.hint && field.hint !== ''" v-html="field.hint"></p>
                        <v-text-field
                          v-model="brandSheet[field.name]"
                          outlined
                          dense
                          :class="field.class? field.class+' mt-0': 'mt-0'"
                          :error-messages="$v.brandSheet[field.name].$error && `${field.label} is required.`"
                          @input="$v.brandSheet[field.name].$touch()"
                          required
                          v-if="field.type === 'textbox'"
                        ></v-text-field>
                        <v-textarea
                          v-model="brandSheet[field.name]"
                          outlined
                          :error-messages="$v.brandSheet[field.name].$error && `${field.label} is required.`"
                          @input="$v.brandSheet[field.name].$touch()"
                          required
                          v-if="field.type === 'textarea'"
                        ></v-textarea>
                        <v-select
                          v-model="brandSheet[field.name]"
                          :items="field.defaultOptions"
                          v-if="field.type === 'select'"
                          @change="changeSelect(field.name, brandSheet[field.name])"
                          outlined
                          dense
                        ></v-select>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-col>
              </v-row>
              <!-- End Section One -->
                          
              <!-- Start Section Two -->
              <v-row>
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">{{brandSheetFormSections.sectionTwo.title}}</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-layout wrap>
                    <v-flex :class="field.class ? field.class : 'xs12 md6'" v-for="(field, index) in brandSheetFormSections.sectionTwo.fields" :key="index">
                      <div>
                        <p class="h4 font-weight-bold mb-2" v-if="field.label !== ''">{{field.label}} <span class="red--text" v-if="field.required">*</span></p>
                        <p v-else class="form-label"></p>
                        <p class="caption caption-text ma-0 pb-2" v-if="field.hint && field.hint !== ''" v-html="field.hint"></p>
                        <div class="d-flex flex-row" v-if="field.name === 'campaignBudget'">
                          <v-select
                            class="currency-select"
                            style="margin-right: 5px;"
                            v-model.number="brandSheet.budgetCurrency"
                            :items="currenyOptions"
                            hide-details
                            dense
                            outlined
                          >
                          </v-select>
                          <v-text-field
                            v-model="brandSheet[field.name]"
                            outlined
                            dense
                            :class="field.class? field.class+' mt-0': 'mt-0'"
                            :error-messages="$v.brandSheet[field.name].$error && `${field.label} is required.`"
                            @input="$v.brandSheet[field.name].$touch()"
                            :placeholder="field.placeholder ? field.placeholder : ''"
                            required
                            :type="field.numberText ? 'number' : ''"
                            v-if="field.type === 'textbox'"
                          ></v-text-field>
                        </div>
                        <v-text-field
                          v-model="brandSheet[field.name]"
                          outlined
                          dense
                          :class="field.class? field.class+' mt-0': 'mt-0'"
                          :error-messages="$v.brandSheet[field.name].$error && `${field.label} is required.`"
                          @input="$v.brandSheet[field.name].$touch()"
                          :placeholder="field.placeholder ? field.placeholder : ''"
                          required
                          :type="field.numberText ? 'number' : ''"
                          v-if="field.type === 'textbox' && field.name !== 'campaignBudget'"
                        ></v-text-field>
                        <v-textarea
                          v-model="brandSheet[field.name]"
                          outlined
                          :error-messages="$v.brandSheet[field.name].$error && `${field.label} is required.`"
                          @input="$v.brandSheet[field.name].$touch()"
                          required
                          v-if="field.type === 'textarea'"
                        ></v-textarea>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-col>
              </v-row>
              <!-- End Section Two -->

              <!-- Start Section Three -->
              <v-row>
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">{{brandSheetFormSections.sectionThree.title}}</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-layout wrap>
                    <v-flex :class="field.class ? field.class : 'xs12 md6'" v-for="(field, index) in brandSheetFormSections.sectionThree.fields" :key="index">
                      <div>
                        <p class="h4 font-weight-bold mb-2" v-if="field.label !== ''">{{field.label}} <span class="red--text" v-if="field.required">*</span></p>
                        <p v-else class="form-label"></p>
                        <p class="caption caption-text ma-0 pb-2" v-if="field.hint && field.hint !== ''" v-html="field.hint"></p>
                        <v-text-field
                          v-model="brandSheet[field.name]"
                          outlined
                          dense
                          :class="field.class? field.class+' mt-0': 'mt-0'"
                          :error-messages="$v.brandSheet[field.name].$error && `${field.label} is required.`"
                          @input="$v.brandSheet[field.name].$touch()"
                          :placeholder="field.placeholder ? field.placeholder : ''"
                          required
                          v-if="field.type === 'textbox'"
                        ></v-text-field>
                        <v-textarea
                          v-model="brandSheet[field.name]"
                          outlined
                          :error-messages="$v.brandSheet[field.name].$error && `${field.label} is required.`"
                          @input="$v.brandSheet[field.name].$touch()"
                          required
                          v-if="field.type === 'textarea'"
                        ></v-textarea>
                        <v-select
                          v-model="brandSheet[field.name]"
                          :items="field.defaultOptions"
                          item-text="text"
                          item-value="value"
                          v-if="field.type === 'select'"
                          outlined
                          dense
                        ></v-select>
                        <v-layout wrap justify-center mb-2 v-if="field.type === 'checkbox'">
                          <v-flex xs12 md12 v-for="df in field.detailFields" :key="df.key">
                            <v-checkbox
                              v-model="brandSheet[field.name]"
                              :label="df.label"
                              :value="df.value"
                              class="mt-0"
                            ></v-checkbox>
                          </v-flex>
                        </v-layout>
                        <div class="mb-3" v-if="field.type === 'file'">
                          <v-btn                      
                            color="blue-grey"
                            class="white--text"
                            @click="$refs.mediaUpload.click()"         
                          >
                            Upload
                            <v-icon
                              right
                              dark
                            >
                              mdi-cloud-upload
                            </v-icon>
                          </v-btn>
                          <div class="mt-3">
                            <v-row v-if="images.length > 0">
                              <v-col
                                v-for="(img, index) in images"
                                :key="index"
                                class="d-flex child-flex"
                                cols="12" sm="12" md="2" lg="1"
                              >
                                <v-hover v-slot:default="{ hover }">
                                  <v-card
                                    flat
                                    tile
                                    class="d-flex"                              
                                    :elevation="hover ? 16 : 2"
                                  >
                                    <v-img                                  
                                      :src="img.url"
                                      :lazy-src="img.url"                                  
                                      class="grey lighten-2"
                                      aspect-ratio="1"
                                    ></v-img>
                                    <v-overlay absolute>
                                      <v-btn dark icon @click="deleteImage(index)">
                                        <v-icon dark color="red">cancel</v-icon>
                                      </v-btn>
                                    </v-overlay>
                                  </v-card>
                                </v-hover>
                              </v-col>
                            </v-row>
                            <v-row v-if="decksFiles.length > 0" >
                              <v-col cols="12" sm="12" md="2" lg="1" v-for="(item, index) in decksFiles" :key="index" align="center">                   
                                <a v-if="item.type.indexOf('pdf') !== -1" :href="item.url" target="_blank">
                                  <v-img
                                      width="67" height="85"
                                      src="/static/img/pdf.png"
                                      aspect-ratio="1"
                                    ></v-img>
                                </a>                                                                                                               
                                <a v-if="item.type.indexOf('ppt') !== -1" :href="item.url" target="_blank">
                                  <v-img
                                      width="67" height="85"
                                      src="/static/img/ppt.png"
                                    ></v-img>
                                </a>
                                <a v-if="item.type.indexOf('doc') !== -1" :href="item.url" target="_blank">
                                  <v-img
                                      width="67" height="85"
                                      src="/static/img/doc.png"
                                    ></v-img>
                                </a>
                                <a v-if="item.type.indexOf('text') !== -1" :href="item.url" target="_blank">
                                  <v-img
                                      width="67" height="85"
                                      src="/static/img/text.png"
                                    ></v-img>
                                </a>                        
                                <v-btn dark icon @click="deleteFile(index)">
                                  <v-icon dark color="red">cancel</v-icon>
                                </v-btn>
                              </v-col>
                            </v-row>
                          </div>
                        </div>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-col>
              </v-row>
              <!-- End Section Three -->

              
              <!-- required field messaage -->
              <v-row v-if="$v.brandSheet.$error">
                <v-col cols="12" class="pb-0">
                  <p class="text-danger font-weight-bold">Please complete all required fields. *</p>
                </v-col>
              </v-row>
              <!-- END required field messaage -->

              <v-row>
                <v-col>
                  <v-btn :disabled="submitting" class="secondary" x-large @click.prevent="submitBrandSheet">
                    <i class="fa fa-circle-o-notch fa-spin" v-if="submitting"></i>
                    Submit
                  </v-btn>
                </v-col>
              </v-row>
              <!-- <v-row>
                <v-col>
                </v-col>
              </v-row> -->
          
            </v-flex>
          </v-layout>
          <!-- End Story Tell -->

          <!-- Start AOK -->
          <v-layout wrap justify-center mb-2 v-if="type === bfsTypes.AOK || type === bfsTypes.Uncut">
            <v-flex xs12 md7 class="content">
              <v-row>
                <v-col cols="12" class="pb-0">
                  <div class="avatar-logo">
                    <img :src="brandSheetLogo" alt="Logo" />
                  </div>
                </v-col>
                <v-col cols="12" class="pt-0">
                  <h2 class="form-title">KOBE Uncut - BRAND FACT SHEET</h2>
                </v-col>
              </v-row>
              <v-row class="mb-4">
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">{{brandSheetAOKFormSections.sectionOne.title}}</p>
                </v-col>
              </v-row>
              <v-row class="mb-4">
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">{{brandSheetAOKFormSections.sectionOne.subtitle}}</p>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <v-img src="/static/img/brand_sheet/aok_bg.png" ></v-img>
                </v-col>
              </v-row>
              <!-- Start Section One -->
              <v-row>
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">LEAD TIME</p>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <p class="mb-0">14 days upon receiving this brand fact sheet and logistics from the client.</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">TIME/DATE OF PUBLISH</p>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <p class="mb-0">Creators are free to post at any preferred time and day during the campaign period.</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">SELECTION CRITERIA</p>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <p class="mb-0 pb-2">Profiles proposed will be screened for audience credibility on KOBE Patented Influencer Management System (IMS)</p>
                  <p class="mb-0">For niche requirements (for example, ethnicity, professions) , please opt for storytell packages instead.</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">CREATORS CONTENT</p>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <p class="mb-0">All contents created by creators are their organic and authentic reviews from their genuine experience. The contents produced are unvetted and serve as user-generated content. The format and platform of the reviews will depend on the creator’s preference.</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">CAMPAIGN INFORMATION SHARING</p>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <p class="mb-0">KOBE will manage the campaign as per information shared by clients in this brand fact sheet. By filling in the brand fact sheet, clients consent to KOBE sharing campaign sensitive information with creators and confirm that all details shared are accurate and final.</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">LOGISTICS ARRANGEMENT</p>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <p class="mb-0 pb-2">It is recommended for our clients to make your own logistics arrangements.</p>
                  <p class="mb-0 pb-2">For clients that are unable to handle logistics, KOBE will offer complimentary logistics service for our clients with products (not including perishable goods or items that require special handling or storage) that are below 2kg and parcel size (length + width + height) does not exceed 120cm.</p>
                  <p class="mb-0 pb-2">Product has to be sent over to KOBE in 1 shipment before it is disseminated to the creators on your behalf.</p>
                  <p class="mb-0 pb-2">There will be a 5 working day turnaround for all logistics arrangements.</p>
                  <p class="mb-0">KOBE will not be responsible for any damaged or lost parcels.</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">ADDITIONAL ENGAGEMENT</p>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <p class="mb-0 pb-2">Kindly note that any additional engagements listed here are not applicable for KOBE Uncut campaigns and you could opt for Storytell campaign and are chargeable, kindly ensure that requirements are stated clearly with your Client Engagement Representative before launching of the campaign:</p>
                  <p class="mb-0 pb-2">● Contest giveaway on social media ● Photoshoot for client ● Video appearance in client’s own production ● Usage of photos/videos from creators as Ads online or offline ● Promo Code Shoutout ● Link in Bio/Swipe Up</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-layout wrap>
                    <v-flex :class="field.class ? field.class : 'xs12 md6'" v-for="(field, index) in brandSheetAOKFormSections.sectionOne.fields" :key="index">
                      <div>
                        <p class="h4 font-weight-bold mb-2" v-if="field.label !== ''">{{field.label}} <span class="red--text" v-if="field.required">*</span></p>
                        <p v-else class="form-label"></p>
                        <p class="caption caption-text ma-0 pb-2" v-if="field.hint && field.hint !== ''" v-html="field.hint"></p>
                        <v-text-field
                          v-model="brandSheet[field.name]"
                          outlined
                          dense
                          :class="field.class? field.class+' mt-0': 'mt-0'"
                          :error-messages="$v.brandSheet[field.name].$error && `${field.label} is required.`"
                          @input="$v.brandSheet[field.name].$touch()"
                          :placeholder="field.placeholder ? field.placeholder : ''"
                          required
                          v-if="field.type === 'textbox'"
                        ></v-text-field>
                        <v-textarea
                          v-model="brandSheet[field.name]"
                          outlined
                          :error-messages="$v.brandSheet[field.name].$error && `${field.label} is required.`"
                          @input="$v.brandSheet[field.name].$touch()"
                          :placeholder="field.placeholder ? field.placeholder : ''"
                          required
                          v-if="field.type === 'textarea'"
                        ></v-textarea>
                        <div class="mb-3" v-if="field.type === 'file'">
                          <v-btn                      
                            color="blue-grey"
                            class="white--text"
                            @click="$refs.mediaUpload.click()"         
                          >
                            Upload
                            <v-icon
                              right
                              dark
                            >
                              mdi-cloud-upload
                            </v-icon>
                          </v-btn>
                          <div class="mt-3">
                            <v-row v-if="images.length > 0">
                              <v-col
                                v-for="(img, index) in images"
                                :key="index"
                                class="d-flex child-flex"
                                cols="12" sm="12" md="2" lg="1"
                              >
                                <v-hover v-slot:default="{ hover }">
                                  <v-card
                                    flat
                                    tile
                                    class="d-flex"                              
                                    :elevation="hover ? 16 : 2"
                                  >
                                    <v-img                                  
                                      :src="img.url"
                                      :lazy-src="img.url"                                  
                                      class="grey lighten-2"
                                      aspect-ratio="1"
                                    ></v-img>
                                    <v-overlay absolute>
                                      <v-btn dark icon @click="deleteImage(index)">
                                        <v-icon dark color="red">cancel</v-icon>
                                      </v-btn>
                                    </v-overlay>
                                  </v-card>
                                </v-hover>
                              </v-col>
                            </v-row>
                            <v-row v-if="decksFiles.length > 0" >
                              <v-col cols="12" sm="12" md="2" lg="1" v-for="(item, index) in decksFiles" :key="index" align="center">                   
                                <a v-if="item.type.indexOf('pdf') !== -1" :href="item.url" target="_blank">
                                  <v-img
                                      width="67" height="85"
                                      src="/static/img/pdf.png"
                                      aspect-ratio="1"
                                    ></v-img>
                                </a>                                                                                                               
                                <a v-if="item.type.indexOf('ppt') !== -1" :href="item.url" target="_blank">
                                  <v-img
                                      width="67" height="85"
                                      src="/static/img/ppt.png"
                                    ></v-img>
                                </a>
                                <a v-if="item.type.indexOf('doc') !== -1" :href="item.url" target="_blank">
                                  <v-img
                                      width="67" height="85"
                                      src="/static/img/doc.png"
                                    ></v-img>
                                </a>
                                <a v-if="item.type.indexOf('text') !== -1" :href="item.url" target="_blank">
                                  <v-img
                                      width="67" height="85"
                                      src="/static/img/text.png"
                                    ></v-img>
                                </a>                        
                                <v-btn dark icon @click="deleteFile(index)">
                                  <v-icon dark color="red">cancel</v-icon>
                                </v-btn>
                              </v-col>
                            </v-row>
                          </div>
                        </div>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-col>
              </v-row>
              <!-- End Section One -->

              
              <!-- required field messaage -->
              <v-row v-if="$v.brandSheet.$error">
                <v-col cols="12" class="pb-0">
                  <p class="text-danger font-weight-bold">Please complete all required fields. *</p>
                </v-col>
              </v-row>
              <!-- END required field messaage -->

              <v-row>
                <v-col>
                  <v-btn :disabled="submitting" class="secondary" x-large @click.prevent="submitBrandSheet">
                    <i class="fa fa-circle-o-notch fa-spin" v-if="submitting"></i> Submit
                  </v-btn>
                </v-col>
              </v-row>
              <!-- <v-row>
                <v-col>
                </v-col>
              </v-row> -->
            </v-flex>
          </v-layout>
          <!-- End AOK -->

          <!-- Start Kobe Lite -->
          <v-layout wrap justify-center mb-2 v-if="type === bfsTypes.KOBE_LITE">
            <v-flex xs12 md7 class="content">
              <v-row>
                <v-col cols="12" class="pb-0">
                  <div class="avatar-logo">
                    <img :src="brandSheetLogo" alt="Logo" />
                  </div>
                </v-col>
                <v-col cols="12" class="pt-0">
                  <h2 class="form-title">KOBE Lite - BRAND FACT SHEET</h2>
                </v-col>
              </v-row>
              <v-row class="mb-4">
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">{{brandSheetKobeLiteFormSections.sectionOne.title}}</p>
                </v-col>
              </v-row>
              <!-- <v-row class="mb-4">
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">{{brandSheetKobeLiteFormSections.sectionOne.subtitle}}</p>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <v-img src="/static/img/brand_sheet/aok_bg.png" ></v-img>
                </v-col>
              </v-row> -->
              <!-- Start Section One -->
              <v-row>
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">LEAD TIME</p>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <p class="mb-0">14 days upon receiving this brand fact sheet and logistics from the client.</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">TIME/DATE OF PUBLISH</p>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <p class="mb-0">Creators are free to post at any preferred time and day during the campaign period.</p>
                </v-col>
              </v-row>
              <!-- <v-row>
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">SELECTION CRITERIA</p>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <p class="mb-0 pb-2">Profiles proposed will be screened for audience credibility on KOBE Patented Influencer Management System (IMS)</p>
                  <p class="mb-0">For niche requirements (for example, ethnicity, professions) , please opt for storytell packages instead.</p>
                </v-col>
              </v-row> -->
              <v-row>
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">CREATORS CONTENT</p>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <p class="mb-0">All contents created by creators are their organic and authentic reviews from their genuine experience. The contents produced are unvetted and serve as user-generated content. The format and platform of the reviews will depend on the creator’s preference.</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">CAMPAIGN INFORMATION SHARING</p>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <p class="mb-0">By filling in the brand fact sheet, clients consent to KOBE sharing campaign sensitive information with creators and confirm that all details shared are accurate and final.</p>
                </v-col>
              </v-row>
              <!-- <v-row>
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">LOGISTICS ARRANGEMENT</p>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <p class="mb-0 pb-2">It is recommended for our clients to make your own logistics arrangements.</p>
                  <p class="mb-0 pb-2">For clients that are unable to handle logistics, KOBE will offer complimentary logistics service for our clients with products (not including perishable goods or items that require special handling or storage) that are below 2kg and parcel size (length + width + height) does not exceed 120cm.</p>
                  <p class="mb-0 pb-2">Product has to be sent over to KOBE in 1 shipment before it is disseminated to the creators on your behalf.</p>
                  <p class="mb-0 pb-2">There will be a 5 working day turnaround for all logistics arrangements.</p>
                  <p class="mb-0">KOBE will not be responsible for any damaged or lost parcels.</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">ADDITIONAL ENGAGEMENT</p>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <p class="mb-0 pb-2">Kindly note that any additional engagements listed here are not applicable for AOK campaigns and you could opt for Storytell campaign and are chargeable, kindly ensure that requirements are stated clearly with your Client Engagement Representative before launching of the campaign:</p>
                  <p class="mb-0 pb-2">● Contest giveaway on social media ● Photoshoot for client ● Video appearance in client’s own production ● Usage of photos/videos from creators as Ads online or offline ● Promo Code Shoutout ● Link in Bio/Swipe Up</p>
                </v-col>
              </v-row> -->
              <v-row>
                <v-col>
                  <v-layout wrap>
                    <v-flex :class="field.class ? field.class : 'xs12 md6'" v-for="(field, index) in brandSheetKobeLiteFormSections.sectionOne.fields" :key="index">
                      <div>
                        <p class="h4 font-weight-bold mb-2" v-if="field.label !== ''">{{field.label}} <span class="red--text" v-if="field.required">*</span></p>
                        <p v-else class="form-label"></p>
                        <p class="caption caption-text ma-0 pb-2" v-if="field.hint && field.hint !== ''" v-html="field.hint"></p>
                        <v-text-field
                          v-model="brandSheet[field.name]"
                          outlined
                          dense
                          :class="field.class? field.class+' mt-0': 'mt-0'"
                          :error-messages="$v.brandSheet[field.name].$error && `${field.label} is required.`"
                          @input="$v.brandSheet[field.name].$touch()"
                          :placeholder="field.placeholder ? field.placeholder : ''"
                          required
                          v-if="field.type === 'textbox'"
                        ></v-text-field>
                        <v-textarea
                          v-model="brandSheet[field.name]"
                          outlined
                          :error-messages="$v.brandSheet[field.name].$error && `${field.label} is required.`"
                          @input="$v.brandSheet[field.name].$touch()"
                          :placeholder="field.placeholder ? field.placeholder : ''"
                          required
                          v-if="field.type === 'textarea'"
                        ></v-textarea>
                        <div class="mb-3" v-if="field.type === 'file'">
                          <v-btn                      
                            color="blue-grey"
                            class="white--text"
                            @click="$refs.mediaUpload.click()"         
                          >
                            Upload
                            <v-icon
                              right
                              dark
                            >
                              mdi-cloud-upload
                            </v-icon>
                          </v-btn>
                          <div class="mt-3">
                            <v-row v-if="images.length > 0">
                              <v-col
                                v-for="(img, index) in images"
                                :key="index"
                                class="d-flex child-flex"
                                cols="12" sm="12" md="2" lg="1"
                              >
                                <v-hover v-slot:default="{ hover }">
                                  <v-card
                                    flat
                                    tile
                                    class="d-flex"                              
                                    :elevation="hover ? 16 : 2"
                                  >
                                    <v-img                                  
                                      :src="img.url"
                                      :lazy-src="img.url"                                  
                                      class="grey lighten-2"
                                      aspect-ratio="1"
                                    ></v-img>
                                    <v-overlay absolute>
                                      <v-btn dark icon @click="deleteImage(index)">
                                        <v-icon dark color="red">cancel</v-icon>
                                      </v-btn>
                                    </v-overlay>
                                  </v-card>
                                </v-hover>
                              </v-col>
                            </v-row>
                            <v-row v-if="decksFiles.length > 0" >
                              <v-col cols="12" sm="12" md="2" lg="1" v-for="(item, index) in decksFiles" :key="index" align="center">                   
                                <a v-if="item.type.indexOf('pdf') !== -1" :href="item.url" target="_blank">
                                  <v-img
                                      width="67" height="85"
                                      src="/static/img/pdf.png"
                                      aspect-ratio="1"
                                    ></v-img>
                                </a>                                                                                                               
                                <a v-if="item.type.indexOf('ppt') !== -1" :href="item.url" target="_blank">
                                  <v-img
                                      width="67" height="85"
                                      src="/static/img/ppt.png"
                                    ></v-img>
                                </a>
                                <a v-if="item.type.indexOf('doc') !== -1" :href="item.url" target="_blank">
                                  <v-img
                                      width="67" height="85"
                                      src="/static/img/doc.png"
                                    ></v-img>
                                </a>
                                <a v-if="item.type.indexOf('text') !== -1" :href="item.url" target="_blank">
                                  <v-img
                                      width="67" height="85"
                                      src="/static/img/text.png"
                                    ></v-img>
                                </a>                        
                                <v-btn dark icon @click="deleteFile(index)">
                                  <v-icon dark color="red">cancel</v-icon>
                                </v-btn>
                              </v-col>
                            </v-row>
                          </div>
                        </div>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-col>
              </v-row>
              <!-- End Section One -->
              
              <!-- required field messaage -->
              <v-row v-if="$v.brandSheet.$error">
                <v-col cols="12" class="pb-0">
                  <p class="text-danger font-weight-bold">Please complete all required fields. *</p>
                </v-col>
              </v-row>
              <!-- END required field messaage -->

              <v-row>
                <v-col>
                  <v-btn :disabled="submitting" class="secondary" x-large @click.prevent="submitBrandSheet">
                    <i class="fa fa-circle-o-notch fa-spin" v-if="submitting"></i> Submit
                  </v-btn>
                </v-col>
              </v-row>
              <!-- <v-row>
                <v-col>
                </v-col>
              </v-row> -->
            </v-flex>
          </v-layout>
          <!-- End Kobe Lite -->

          <!-- Start AOK -->
          <v-layout wrap justify-center mb-2 v-if="type === bfsTypes.UGC || type === bfsTypes.UGC">
            <v-flex xs12 md7 class="content">
              <v-row>
                <v-col cols="12" class="pb-0">
                  <div class="avatar-logo">
                    <img :src="brandSheetLogo" alt="Logo" />
                  </div>
                </v-col>
                <v-col cols="12" class="pt-0">
                  <h2 class="form-title">UGC (User-Generated-Content) Videos Application Form</h2>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="pb-0">
                  <v-checkbox
                    v-model="brandSheet['aggreedKobeServiceInclude']"
                    label="I am aware that kobe’s full service of S$15k and up, includes: "
                    value="aggreedKobeServiceInclude"
                  ></v-checkbox>
                  <p class="text-danger font-weight-bold" v-if="$v.brandSheet['aggreedKobeServiceInclude'].$error">This field is required!</p>
                  <p>
                    <ul>
                      <li>Marketing goal, objective, and influence strategy consultation, incorporating the availability heuristic, bandwagon effect, and clustering effect for cognitive and emotive influence.</li>
                      <li>Development of social media content concepts and strategies using 7X award-winning A.U.D.I framework.</li>
                      <li>Curated creator identification through patented proprietary software, unveiling deep insights into social performance, audience demographics, and creator interest and personality profiling.</li>
                      <li>Comprehensive creator relationship management services, including content curation, quality assurance, vetting and scheduling.</li>
                      <li>Tailored content direction and brief design aligned with marketing objectives, encompassing recommendations for hashtags, captions, content direction, platform selection, optimal timing, and social SEO optimization.</li>
                      <li>Up to 3 accesses to our Influencer Management System® to streamline influencer campaign management.</li>
                      <li>Access to dedicated account managers, strategy planners, and community curators, providing expert recommendations and support.</li>
                    </ul>
                  </p>
                  <p>Lead time: 4 weeks</p>
                </v-col>
              </v-row>
              <v-row>
                <!-- <v-col cols="12" class="pb-0">
                  <p class="mb-0">To proceed with UGC videos application, please complete the following.</p>
                  <v-radio-group v-model="brandSheet['ugcVideo']" row>
                    <v-radio label="$5k 8 UGC videos" value="$5k 8 UGC videos"></v-radio>
                    <v-radio label="$8k 16 UGC videos" value="$8k 16 UGC videos"></v-radio>
                    <v-radio label="$12k 30 UGC videos" value="$12k 30 UGC videos"></v-radio>
                  </v-radio-group>
                  <p class="text-danger font-weight-bold" v-if="!brandSheet['ugcVideo']">This field is required!</p>
                  <p><strong>Includes:</strong></p>
                  <p>
                    <ul>
                      <li>Utilization and exposure to a nano-creator base of 10,000 individuals with follower counts up to 5,000.</li>
                      <li>Guidance and assistance in the creation of email invitations for UGC creator outreach and engagement.</li>
                      <li>Immediate notifications when content is posted, with seamless collection of content assets for future use.</li>
                      <li>Direct access to UGC creator contact information for the purpose of building relationships and facilitating additional collaborations.</li>
                    </ul>
                  </p>
                </v-col> -->
                <v-col cols="12" class="pb-0">
                  <p>Process:</p>                
                  <v-img src="/static/img/brand_sheet/ugc_process.png" style="max-width:800px"></v-img>
                </v-col>
              </v-row>
              <!-- 
              <v-row class="mb-4">
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">{{brandSheetAOKFormSections.sectionOne.title}}</p>
                </v-col>
              </v-row>
              <v-row class="mb-4">
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">{{brandSheetAOKFormSections.sectionOne.subtitle}}</p>
                </v-col>
              </v-row>
              -->
              <!-- Start Section One -->
              <v-row>
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">TIME/DATE OF PUBLISH</p>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <p class="mb-0">Creators are free to post at any preferred time and day during the campaign period.</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">INFLUENCER SELECTION</p>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <p class="mb-0">Influencer selection is interest and response based. Based on what you complete within this form, the information will be distributed to 10,000 individuals with follower counts up to 3,000. The interested recipients will respond accordingly.You are not allowed to modify the requirements of creator quality, quantity, specification.</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">CREATORS CONTENT</p>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <p class="mb-0">All contents created by creators are their organic and authentic reviews from their genuine experience. The contents produced are unvetted and serve as user-generated content. The format and platform of the reviews will depend on the creator’s preference. You are not allowed to request for reshoot, edits or amendments.</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">INFORMATION SHARING</p>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <p class="mb-0">KOBE will manage the campaign as per information shared by clients in this brand fact sheet. By filling in the brand fact sheet, clients consent to KOBE sharing campaign sensitive information with creators and confirm that all details shared are accurate and final.</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">LOGISTICS ARRANGEMENT</p>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <p>For products</p>
                  <ol>
                    <li>Client to send products to creators directly for free</li>
                    <li>Client to arrange a pick-up point for creators to collect the products directly</li>
                    <li>Creator can make the purchase of product with attached receipt for 100% reimbursement from client</li>
                  </ol>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <p>For experience</p>
                  <ol>
                    <li>Creator attend the experience directly and client to verify</li>
                    <li>Creator can make the purchase of experience with attached receipt for 100% reimbursement from client</li>
                  </ol>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">UGC VIDEOS TRACKING</p>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <p class="mb-0 pb-2">You will receive email notification via your email address provided below each time a creator submits their content. The campaign concludes once the number of UGC videos achieves the number agreed.</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="pb-0">
                  <p class="h4 font-weight-bold mb-0">POST CAMPAIGN</p>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <p class="mb-0 pb-2">You will have direct access to creator contact information for the purpose of relationship building, additional collaborations. Kobe will assume a non-interventionist role and will not levy any charges or engage in mediation with respect to the relationship. You are granted unrestricted discretion to communicate and negotiate according to your preferences.</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-layout wrap>
                    <v-flex :class="field.class ? field.class : 'xs12 md6'" v-for="(field, index) in brandSheetAOKFormSections.sectionOne.fields" :key="index">
                      <div>
                        <p class="h4 font-weight-bold mb-2" v-if="field.label !== ''">{{field.label}} <span class="red--text" v-if="field.required">*</span></p>
                        <p v-else class="form-label"></p>
                        <p class="caption caption-text ma-0 pb-2" v-if="field.hint && field.hint !== ''" v-html="field.hint"></p>
                        <v-text-field
                          v-model="brandSheet[field.name]"
                          outlined
                          dense
                          :class="field.class? field.class+' mt-0': 'mt-0'"
                          :error-messages="$v.brandSheet[field.name].$error && `${field.label} is required.`"
                          @input="$v.brandSheet[field.name].$touch()"
                          :placeholder="field.placeholder ? field.placeholder : ''"
                          required
                          v-if="field.type === 'textbox'"
                        ></v-text-field>
                        <v-textarea
                          v-model="brandSheet[field.name]"
                          outlined
                          :error-messages="$v.brandSheet[field.name].$error && `${field.label} is required.`"
                          @input="$v.brandSheet[field.name].$touch()"
                          :placeholder="field.placeholder ? field.placeholder : ''"
                          required
                          v-if="field.type === 'textarea'"
                        ></v-textarea>
                        <div v-if="field.name === 'productExperienceType'">
                          <v-radio-group v-model="brandSheet[field.name]" row>
                            <v-radio label="Deliver directly" value="Deliver directly"></v-radio>
                            <v-radio label="Pick Up Point" value="Pick Up Point"></v-radio>
                            <v-radio label="Reimbursement Basis" value="Reimbursement Basis"></v-radio>
                          </v-radio-group>
                        </div>
                        <!-- for UGC video upload -->
                        <div class="mb-3" v-if="field.name === 'sampleVideoContent'">
                          <div class="d-flex flex-row" v-for="(vt, index) in brandSheet.sampleVideoContent" :key="index">
                            <v-text-field
                              v-model="vt.link"
                              outlined
                              dense
                              class="mt-0"
                              placeholder=""
                            ></v-text-field>
                            <v-btn
                              color="danger"
                              @click="brandSheet.sampleVideoContent.splice(index, 1)"
                              text
                              x-small
                              v-if="brandSheet.sampleVideoContent.length > 1">
                              <v-icon color="red">mdi-delete-forever</v-icon>
                            </v-btn>
                          </div>
                          <div class="text-right">
                            <v-btn
                            small
                            color="secondary"
                            @click="addVideoURL()">
                              <v-icon small>mdi-plus</v-icon> Add
                            </v-btn>
                          </div>
                          <v-btn                      
                            color="blue-grey"
                            class="white--text"
                            @click="$refs.videoUpload.click()"         
                          >
                            Upload
                            <v-icon
                              right
                              dark
                            >
                              mdi-cloud-upload
                            </v-icon>
                          </v-btn>
                          <div class="mt-3">
                            <v-row v-if="videos.length > 0">
                              <v-col
                                v-for="(vdo, index) in videos"
                                :key="index"
                                class="d-flex child-flex"
                                cols="12" sm="12" md="2" lg="1"
                              >
                                <v-hover v-slot:default="{ hover }">
                                  <v-card
                                    flat
                                    tile
                                    class="d-flex"                              
                                    :elevation="hover ? 16 : 2"
                                  >
                                    <v-img                                  
                                      :src="vdo.url"
                                      :lazy-src="vdo.url"                                  
                                      class="grey lighten-2"
                                      aspect-ratio="1"
                                    ></v-img>
                                    <v-overlay absolute>
                                      <v-btn dark icon @click="deleteVideo(index)">
                                        <v-icon dark color="red">cancel</v-icon>
                                      </v-btn>
                                    </v-overlay>
                                  </v-card>
                                </v-hover>
                              </v-col>
                            </v-row>
                            <v-row v-if="videoFiles.length > 0" >
                              <v-col cols="12" sm="12" md="2" lg="1" v-for="(item, index) in videoFiles" :key="index" align="center">                   
                                <a :href="item.url" target="_blank">
                                  <v-img
                                      width="67" height="85"
                                      src="/static/img/text.png"
                                      aspect-ratio="1"
                                    ></v-img>
                                </a>                            
                                <v-btn dark icon @click="deleteVideoFile(index)">
                                  <v-icon dark color="red">cancel</v-icon>
                                </v-btn>
                              </v-col>
                            </v-row>
                          </div>
                        </div>
                        <!-- for UGC file upload -->
                        <div class="mb-3" v-if="field.name === 'marketingCollaterals'">
                          <div class="d-flex flex-row" v-for="(mct, index) in brandSheet.marketingURL" :key="index">
                            <v-text-field
                              v-model="mct.link"
                              outlined
                              dense
                              class="mt-0"
                              placeholder=""
                            ></v-text-field>
                            <v-btn
                              color="danger"
                              @click="brandSheet.marketingURL.splice(index, 1)"
                              text
                              x-small
                              v-if="brandSheet.marketingURL.length > 1">
                              <v-icon color="red">mdi-delete-forever</v-icon>
                            </v-btn>
                          </div>
                          <div class="text-right">
                            <v-btn
                            small
                            color="secondary"
                            @click="addMarketingURL()">
                              <v-icon small>mdi-plus</v-icon> Add
                            </v-btn>
                          </div>
                          <v-btn                      
                            color="blue-grey"
                            class="white--text"
                            @click="$refs.mediaUpload.click()"         
                          >
                            Upload
                            <v-icon
                              right
                              dark
                            >
                              mdi-cloud-upload
                            </v-icon>
                          </v-btn>
                          <div class="mt-3">
                            <v-row v-if="images.length > 0">
                              <v-col
                                v-for="(img, index) in images"
                                :key="index"
                                class="d-flex child-flex"
                                cols="12" sm="12" md="2" lg="1"
                              >
                                <v-hover v-slot:default="{ hover }">
                                  <v-card
                                    flat
                                    tile
                                    class="d-flex"                              
                                    :elevation="hover ? 16 : 2"
                                  >
                                    <v-img                                  
                                      :src="img.url"
                                      :lazy-src="img.url"                                  
                                      class="grey lighten-2"
                                      aspect-ratio="1"
                                    ></v-img>
                                    <v-overlay absolute>
                                      <v-btn dark icon @click="deleteImage(index)">
                                        <v-icon dark color="red">cancel</v-icon>
                                      </v-btn>
                                    </v-overlay>
                                  </v-card>
                                </v-hover>
                              </v-col>
                            </v-row>
                            <v-row v-if="decksFiles.length > 0" >
                              <v-col cols="12" sm="12" md="2" lg="1" v-for="(item, index) in decksFiles" :key="index" align="center">                   
                                <a v-if="item.type.indexOf('pdf') !== -1" :href="item.url" target="_blank">
                                  <v-img
                                      width="67" height="85"
                                      src="/static/img/pdf.png"
                                      aspect-ratio="1"
                                    ></v-img>
                                </a>                                                                                                               
                                <a v-if="item.type.indexOf('ppt') !== -1" :href="item.url" target="_blank">
                                  <v-img
                                      width="67" height="85"
                                      src="/static/img/ppt.png"
                                    ></v-img>
                                </a>
                                <a v-if="item.type.indexOf('doc') !== -1" :href="item.url" target="_blank">
                                  <v-img
                                      width="67" height="85"
                                      src="/static/img/doc.png"
                                    ></v-img>
                                </a>
                                <a v-if="item.type.indexOf('text') !== -1" :href="item.url" target="_blank">
                                  <v-img
                                      width="67" height="85"
                                      src="/static/img/text.png"
                                    ></v-img>
                                </a>                        
                                <v-btn dark icon @click="deleteFile(index)">
                                  <v-icon dark color="red">cancel</v-icon>
                                </v-btn>
                              </v-col>
                            </v-row>
                          </div>
                        </div>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-col>
              </v-row>
              <!-- End Section One -->

              
              <!-- required field messaage -->
              <v-row v-if="$v.brandSheet.$error">
                <v-col cols="12" class="pb-0">
                  <p class="text-danger font-weight-bold">Please complete all required fields. *</p>
                </v-col>
              </v-row>
              <!-- END required field messaage -->
              <v-checkbox
                class="h4 font-weight-bold mb-2 prefer-video-chk"
                v-model="brandSheet['preferVideosWithoutCreatorsPosting']"
                label="I prefer to receive the videos without the creators posting it on their social media platform."
                value="preferVideosWithoutCreatorsPosting"
              ></v-checkbox>
              <v-row>
                <v-col>
                  <v-btn :disabled="submitting" class="secondary" x-large @click.prevent="submitBrandSheet">
                    <i class="fa fa-circle-o-notch fa-spin" v-if="submitting"></i> Submit
                  </v-btn>
                </v-col>
              </v-row>
              <!-- <v-row>
                <v-col>
                </v-col>
              </v-row> -->
            </v-flex>
          </v-layout>
          <!-- End AOK -->

          <!-- File Upload -->
          <input
            type="file"
            name="media"
            style="display: none"
            ref="mediaUpload"
            id="fileToUpload"
            accept="image/*, .pdf, .ppt, .txt, .doc, .docx"
            @change="prepareUpload"
          />
          <!-- Video Upload -->
          <input
            type="file"
            name="video"
            style="display: none"
            ref="videoUpload"
            id="videoToUpload"
            accept="video/*"
            @change="prepareVideoUpload"
          />
        </v-form>
      </v-container>
    </v-card>
  </v-app>
</template>
<script>
import config from '@/config';
import logoDataURL from '@/config/logoDataURL'
import campaignConfig from './config';
import campaignPDF from './campaignPDF'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import campaignAPIs from './campaignAPIs';
import Jimp from 'jimp';
import utils from '@/utils';
import dialCodes from './dialCodes.json'
// import * as pdfMake from 'pdfmake/build/pdfmake.js';
// import * as pdfFonts from './custom-fonts';
// const vfs = pdfFonts.pdfMake.vfs;
// setTimeout(() => {
//   pdfMake.vfs = vfs
// }, 100)

export default {
  name: 'CreateBrandSheetForm',
  mixins: [validationMixin],
  validations: function() {
    let validationRules = {
      brandSheet: {
      }
    };
    if (this.type === this.campaignTypes.STORY_TELL) {
      // validations for story tell
      let multiplevalidations = [
        'sectionOne',
        'sectionTwo',
        'sectionThree'
      ];
      multiplevalidations.map(val => {
        this.brandSheetFormSections[val].fields.forEach(field => {
          validationRules['brandSheet'][field.name] = field.required ? {required} : '';
        })
      })
    } else if (this.type === this.campaignTypes.AOK) {
      // validations for AOK/Uncut
      let multiplevalidations = [
        'sectionOne'
      ];
      multiplevalidations.map(val => {
        this.brandSheetAOKFormSections[val].fields.forEach(field => {
          validationRules['brandSheet'][field.name] = field.required ? {required} : '';
        })
      })
    } else if (this.type === this.bfsTypes.KOBE_LITE) {
      // validations for Kobe Lite
      let multiplevalidations = [
        'sectionOne'
      ];
      multiplevalidations.map(val => {
        this.brandSheetKobeLiteFormSections[val].fields.forEach(field => {
          validationRules['brandSheet'][field.name] = field.required ? {required} : '';
        })
      })
    } else {
      // validations for UGC Form
      let multiplevalidations = [
        'sectionOne'
      ];
      multiplevalidations.map(val => {
        this.brandSheetAOKFormSections[val].fields.forEach(field => {
          validationRules['brandSheet'][field.name] = field.required ? {required} : '';
        })
      })
      // validationRules.brandSheet.aggreedKobeServiceInclude = {
      //   required
      // }
      // validationRules.brandSheet.ugcVideo = {
      //   required
      // }
    }
    return validationRules
  },
  data () {
    return {
      dialog: true,
      submitting: false,
      valid: true,
      campaignID: '',
      type: '',
      campaignTypes: campaignConfig.campaignType,
      bfsTypes: campaignConfig.bfsTypes,
      brandSheetFormSections: campaignConfig.brandSheetFormSections,
      brandSheetAOKFormSections: campaignConfig.brandSheetAOKFormSections,
      brandSheetKobeLiteFormSections: campaignConfig.brandSheetKobeLiteFormSections,
      brandSheetUGCFormSections: campaignConfig.brandSheetUGCFormSections,
      brandSheetLogo: logoDataURL.logo || '/static/img/kobe_bg_main.png',
      brandSheet: {
        mobileCountry: 'Singapore',
        age: [],
        gender: config.userGenders.NON_BINARY,
        budgetCurrency: 'USD',
        sampleVideoContent: [{
          link: ''
        }],
        marketingURL: [{
          link: ''
        }]
      },
      uploadFiles: [],
      deleteObjectKeys: [],
      images: [],
      decksFiles: [],
      decksMedia: [],
      deleteVideoObjectKeys: [],
      videos: [],
      videoFiles: [],
      videosMedia: [],
      countriesCode: dialCodes,
      currenyOptions: [
        'SGD',
        'USD',
        'IDR',
        'PHP',
        'THB',
        'MYR',
        'VND'
      ]
    }
  },
  methods: {
    close() {
      this.$router.push({path: '/client'})
    },
    async submitBrandSheet() {
      this.$v.$touch()
      if (this.$v.brandSheet.$error) {
        return false
      }
      const brandSheet = Object.assign(this.brandSheet, {
        campaignID: this.campaignID,
        type: this.type
      });
      this.$swal({
        title: 'Double Check!',
        text: 'Make sure you filled all the required information',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(result => {
        if (result.value) {
          this.submitting = true;
          let formData = new FormData();
          let files = this.decksMedia;
          let vdofiles = this.videosMedia;
          formData.append('brandSheet', JSON.stringify(brandSheet));
          for (let val of files) {
            formData.append('uploadFile', val);
          }
          for (let val of vdofiles) {
            formData.append('uploadFile', val);
          }
          campaignAPIs
            .createBrandSheet(formData)
            .then(async (response) => {
              // generate pdf
              await this.sendBFSEmail(response)
              // Dismiss modal by triggering the click event on Close button
              this.close();
              // Update submitting status
              this.submitting = false;
              this.deleteObjectKeys = []
              this.deleteVideoObjectKeys = []
              // Show success message
              this.$swal({
                text: 'Brand Fact Sheet Created',
                type: 'success'
              }).then(result => {
                if (result.value) {
                  this.$router.push({path: '/'})
                }
              })
            })
            .catch(error => {
              // Update submitting status
              this.submitting = false;
              // Request failed.
              console.log('error', error);
              this.$swal({
                text: 'Error saving brand fact sheet.',
                type: 'error'
              });
            });
        }
      });
    },
    prepareUpload(e) {
      const uploadedFiles = Object.keys(e.target.files).map(i => e.target.files[i]);
      uploadedFiles.forEach(element => {
        let mediaType = element.type.split('/')[0];
        let fileType = element.name.split('.')[1];

        if (mediaType !== 'image' && fileType !== 'pdf' && fileType !== 'doc' && fileType !== 'ppt' && fileType !== 'txt' && fileType !== 'docx') {
          this.$swal('File Type Not Supported, Please select a video or an image');
        } else if (mediaType === 'image') {
          const reader = new FileReader();
          reader.readAsDataURL(element);
          reader.onload = e => {
            let buffer = e.target.result;
            Jimp.read(buffer, (err, img) => {
              if (err) console.error(111, err);
              img
                .resize(500, Jimp.AUTO)
                .quality(100)
                .getBase64(Jimp.MIME_PNG, (err, buff) => {
                  if (err) console.error(222, err);
                  let file = utils.func.dataURLtoFile(buff, element.name);
                  this.decksMedia.push(file);
                  this.images.push({
                    url: buff,
                    src: buff,
                    name: element.name
                  });
                });
            });
          };
          // reset the input
          e.target.value = '';
        } else {
          this.decksFiles.push(element);
          this.decksMedia.push(element);
          const reader = new FileReader();
          reader.readAsArrayBuffer(element);
          e.target.value = '';
        }
      });
    },
    deleteImage(imgIndex) {
      let imgURl = this.images[imgIndex].url;
      let filename = this.images[imgIndex].url.substring(this.images[imgIndex].url.lastIndexOf('/') + 1)
      this.deleteObjectKeys.push(filename)
      this.images.splice(imgIndex, 1)
      let DecksMediaIndex = this.decksMedia.findIndex(item => item.url === imgURl)
      if (DecksMediaIndex !== -1) this.decksMedia.splice(DecksMediaIndex, 1)
    },
    deleteFile(fileIndex) {
      let fileURL = ''
      if (this.decksFiles[fileIndex].url) {
        fileURL = this.decksFiles[fileIndex].url;
        let fileName = fileURL.substring(fileURL.lastIndexOf('/') + 1)
        this.deleteObjectKeys.push(fileName)
      }
      this.decksFiles.splice(fileIndex, 1)
      let DecksMediaIndex = this.decksMedia.findIndex(item => item.url === fileURL)
      if (DecksMediaIndex !== -1) this.decksMedia.splice(DecksMediaIndex, 1)
    },
    // prepare video upload
    prepareVideoUpload(e) {
      const uploadedFiles = Object.keys(e.target.files).map(i => e.target.files[i]);
      uploadedFiles.forEach(element => {
        let mediaType = element.type.split('/')[0];
        // let fileType = element.name.split('.')[1];

        if (mediaType !== 'video') {
          this.$swal('File Type Not Supported, Please select a video');
        } else if (mediaType === 'video') {
          const reader = new FileReader();
          reader.readAsDataURL(element);
          reader.onload = e => {
            let buff = e.target.result;
            let file = utils.func.dataURLtoFile(buff, element.name);
            this.videosMedia.push(file);
            this.videos.push({
              url: buff,
              src: buff,
              name: element.name
            });
          };
          // reset the input
          e.target.value = '';
        } else {
          this.videoFiles.push(element);
          this.videosMedia.push(element);
          const reader = new FileReader();
          reader.readAsArrayBuffer(element);
          e.target.value = '';
        }
      });
    },
    deleteVideo(vdoIndex) {
      let imgURl = this.videos[vdoIndex].url
      let filename = this.videos[vdoIndex].url.substring(this.videos[vdoIndex].url.lastIndexOf('/') + 1)
      this.deleteVideoObjectKeys.push(filename)
      this.videos.splice(vdoIndex, 1)
      let vdoMediaIndex = this.videosMedia.findIndex(item => item.url === imgURl)
      if (vdoMediaIndex !== -1) this.videosMedia.splice(vdoMediaIndex, 1)
    },
    deleteVideoFile(fileIndex) {
      let fileURL = ''
      if (this.videoFiles[fileIndex].url) {
        fileURL = this.videoFiles[fileIndex].url;
        let fileName = fileURL.substring(fileURL.lastIndexOf('/') + 1)
        this.deleteVideoObjectKeys.push(fileName)
      }
      this.videoFiles.splice(fileIndex, 1)
      let DecksMediaIndex = this.videosMedia.findIndex(item => item.url === fileURL)
      if (DecksMediaIndex !== -1) this.videosMedia.splice(DecksMediaIndex, 1)
    },
    changeSelect(name, value) {
      if (name === 'mobileCountry') {
        let optionOne = this.countriesCode.find(o => o.cn === value)
        if (optionOne) {
          this.brandSheet.mobilePhone = optionOne.dc
        }
      }
      return true
    },
    getCampaignInfo(campaignID) {
      campaignAPIs
      .getCampaignInfoForBrandSheet(campaignID)
      .then(async (response) => {
        let invalidCampaign = false
        let errMessage = ''
        if (!response.id) {
          invalidCampaign = true
          errMessage = 'Campaign Not Found!'
        }
        // if (!response.type || (response.type !== this.campaignTypes.STORY_TELL && response.type !== this.campaignTypes.AOK)) {
        //   invalidCampaign = true
        //   errMessage = 'Invalid Campaign Type.'
        // }
        if (invalidCampaign) {
          this.$swal({
            title: 'Error',
            text: errMessage,
            type: 'error'
          }).then(() => {
            this.$router.push({path: '/'})
          });
        }
        this.campaignID = response.id
        this.type = response.type
      })
      .catch(error => {
        console.log('error', error.message);
        this.$swal({
          title: 'Error',
          text: error.response.data,
          type: 'error'
        }).then(() => {
          this.$router.push({path: '/'})
        });
      })
    },
    async sendBFSEmail(response) {
      let doc = await campaignPDF.generateBFS(response)
      campaignPDF
      .generatePDF(doc)
      .then(async (pdfData) => {
        let bfsBaseFmt = await campaignPDF.generateBasePDF(doc)
        let formData = new FormData();
        formData.append('id', response.id)
        formData.append('bfsFileBase', bfsBaseFmt)
        formData.append('bfsFile', pdfData)
        await campaignAPIs.sendBFSEmail(formData)
        return true
      })
      .catch(error => {
        console.log('error in converting PDF', error);
      });
    },
    addVideoURL() {
      this.brandSheet.sampleVideoContent.push({
        link: ''
      })
    },
    addMarketingURL() {
      this.brandSheet.marketingURL.push({
        link: ''
      })
    }
  },
  mounted() {
    let campaignID = this.$route.params.campaignId;
    if (campaignID === 'storytell') {
      this.type = this.bfsTypes.STORY_TELL
    } else if (campaignID === 'uncut') {
      this.type = this.bfsTypes.AOK
    } else if (campaignID === 'kobe-lite') {
      this.type = this.bfsTypes.KOBE_LITE
    } else if (campaignID === 'ugcvideos') {
      this.type = this.bfsTypes.UGC
    } else {
      this.getCampaignInfo(campaignID)
    }
    this.changeSelect('mobileCountry', this.brandSheet.mobileCountry)
  }
}
</script>
<style lang="scss">
  .v-dialog--fullscreen {
    scroll-behavior: smooth;
  }
  .brand-fact-sheet-form .prefer-video-chk label {
    font-weight: bold!important;
  }
  .brand-fact-sheet-form .currency-select {
    width: 90px;
    max-width: 90px;
  }
</style>
<style scoped>
  .brand-fact-sheet-page {
    height: 100vh;
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  .bg-soft-grey {
    background-color: #f6f6f6;
  }

  .bg--white {
    background-color: #fff;
  }

  .v-text-field-sm{
    width: 320px;
  }

  .form-label {
    min-height: 22px;
  }

  .caption-text {
    color: var(--v-theme-secondary, #3F3FFF);
  }

  /* .td-error {
    margin-bottom: -20px;
    right: 16px;
  } */

  .td-error, .alert-error {
    display: inline-block;
    font-size: 12px;
    right: 15px;
    padding: 5px;
    margin-bottom: 0px;
    color: #fff!important;
  }

  .alert-error {
    right: 0
  }

  .checkboxes-error {
    margin-top: -15px;
  }

  .d-sm-table-cell {
    height: auto!important;
    padding: 0;
    padding-left: 15px;
  }

  .v-card {
    background-color: rgb(204, 204, 204)!important;
  }

  .content {
    max-width: 100%!important;
    background-color: #fff;
    padding: 50px;
  }

  .avatar-logo {
    width: 120px!important;
    min-width: 120px!important;
    height: auto!important;
    margin: 0 auto;
    transition: all 0.5s ease-out;
  }

  .avatar-logo img {
    display: block;
    width: 120px;
  }
  
  .form-title {
    margin-top: 0;
    text-align: center;
    font-weight: 600;
    /* padding: 40px; */
    transition: all 0.5s ease-out;
  }

  @media (max-width: 768px) {
    .content {
      padding: 20px;
    }
  }
  
  @media (max-width: 600px) {
    .avatar-logo {
      height: auto!important;
      min-width: 100%!important;
      width: 100%!important;
    }
    
    .form-title {
      float: none;
      padding: 0;
      font-size: 25px;
      width: 100%;
      text-align: center;
    }

    .float-xs-left {
      float: left;
    }

    .td-error, .alert-error {
      width: 100%;
      right: 0;
    }

    .pt-xs-5 {
      padding-top: 15px
    }

    .mb-xs-0 {
      margin-bottom: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// BrandSheetForm.vue?c861f9ac